import { Tabs } from "radix-ui";
import { useGuardedNavigate } from "../../lib/guard.tsx";
import { usePlan } from "../../lib/plan.tsx";
import { Alert, PageHeader } from "../../components/ui.tsx";
import { WorkshopTab } from "./WorkshopTab.tsx";
import { AxesTab } from "./AxesTab.tsx";
import { UnitsTab } from "./UnitsTab.tsx";
import { GroupsTab } from "./GroupsTab.tsx";
import { ParticipantsTab } from "./ParticipantsTab.tsx";
import { HistoryTab } from "./HistoryTab.tsx";
import { usePageTitle } from "../../lib/nav.tsx";

const TABS = [
  { id: "oficina", label: "Oficina", C: WorkshopTab },
  { id: "eixos", label: "Eixos", C: AxesTab },
  { id: "unidades", label: "Unidades", C: UnitsTab },
  { id: "grupos", label: "Grupos", C: GroupsTab },
  { id: "participantes", label: "Participantes", C: ParticipantsTab },
  { id: "historico", label: "Histórico", C: HistoryTab },
] as const;

/** T13: instructor-only. The tab lives in the URL so links and browser back work. */
export function SettingsPage({ tab }: { tab?: string | undefined }) {
  const plan = usePlan();
  const go = useGuardedNavigate();
  const current = TABS.some((t) => t.id === tab) ? tab! : "oficina";
  usePageTitle(`Configurações: ${TABS.find((t) => t.id === current)!.label}`, plan.name);

  if (!plan.capabilities.can_manage) {
    return <Alert tone="warn" title="Somente o instrutor">As configurações da oficina são gerenciadas pelo instrutor.</Alert>;
  }
  return (
    <>
      <PageHeader title="Configurações da oficina" subtitle="Identificação, estrutura, grupos, participantes e histórico." />
      <Tabs.Root value={current} onValueChange={(v) => go(`/planos/${plan.id}/configuracoes/${v}`)}>
        <Tabs.List aria-label="Configurações" className="mb-5 flex gap-1 overflow-x-auto border-b border-line">
          {TABS.map((t) => (
            <Tabs.Trigger
              key={t.id}
              value={t.id}
              className="elevate -mb-px min-h-10 shrink-0 rounded-t-ctl border-b-2 border-transparent px-3 py-2 text-sm font-semibold text-muted transition-[color,border-color] duration-[var(--duration-base)] hover:text-ink data-[state=active]:border-accent data-[state=active]:text-primary"
            >
              {t.label}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {TABS.map((t) => (
          <Tabs.Content key={t.id} value={t.id}>
            {current === t.id && <t.C />}
          </Tabs.Content>
        ))}
      </Tabs.Root>
    </>
  );
}
